import React from "react";
import ReactDOM from "react-dom";
import { Button } from "@mui/material";
import "../../Assets/Styles/Modal.css";

const Modal = ({ isOpen, onClose, children, style = { maxWidth: "500px" }, outsideDisabled = false }) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="modal-overlay " onClick={!outsideDisabled ? onClose : () => {}}>
      <div
        className={`modal-content max-h-[80vh] relative !py-4 sm:!pt-10 md:!px-4`}
        style={style}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="absolute top-2 sm:top-4 right-4 text-gray-500 hover:text-red-500
           bg-red-200 bg-opacity-50 rounded-full p-1
          transition-all duration-300 ease-in-out transform hover:scale-110 focus:outline-none"
          onClick={onClose}
          aria-label="Close modal"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="size-6  sm:size-8"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <div className="">{children}</div>
      </div>
    </div>,
    document.getElementById("modal-root")
  );
};

export default Modal;

